module.exports = __webpack_public_path__ + "img/543.1347d1d4.png";